import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import MoneyFormat from "Base/MoneyFormat";
import ErrorsManager from "Base/ErrorsManager";

export default new class FreeBetsController {
    constructor() {
        this.init();
        this.addListeners();
    }

    init() {

    }

    addListeners() {
        GlobalDispatcher.add('stateEnd:freeSpinsOutState', this.onEndFreeSpinsOutState, this);
        GlobalDispatcher.add('stateEnd:requestRollingState', this.onEndRequestRollingState, this);
        GlobalDispatcher.add('stateStart:idleState', this.onStartIdleState, this);
    }

    startFreeRounds() {
        EntryPoint.GameModel.freeBetsStarted = true;
        EntryPoint.GameModel.bet = EntryPoint.GameModel.freeBets.ba;
        EntryPoint.AutoPlaySettings.paused = true;
    }

    onEndRequestRollingState() {
        if (EntryPoint.GameModel.freeBets && EntryPoint.GameModel.freeBets.spins >= 0) {
            GlobalDispatcher.dispatch('topMessageContainer:setText', {
                message: 'label_free_rounds_counter_title',
                params: [EntryPoint.GameModel.freeBets.spins]
            });
        }
    }

    onStartIdleState() {
        //console.log('EntryPoint.GameModel.isFreeSpins', EntryPoint.GameModel.isFreeSpins, EntryPoint.GameModel.freeBets);
        if (EntryPoint.GameModel.freeBets && !EntryPoint.GameModel.isFreeSpins) {
            let popupData = null;
            let messagesData = null;
            if (EntryPoint.GameModel.freeBets.spins > 0 && !EntryPoint.GameModel.freeBetsStarted) {
                popupData = {
                    title: {text: 'label_free_rounds_award_title'},
                    message: {text: 'label_free_rounds_award_text', params: [EntryPoint.GameModel.freeBets.spins]},
                    confirmCallback: this.startFreeRounds,
                    confirmContext: this,
                    type: 'message'
                };
                messagesData = {
                    message: 'label_free_rounds_counter_title',
                    params: [EntryPoint.GameModel.freeBets.spins]
                };
            } else if (EntryPoint.GameModel.freeBets.spins === 0 && EntryPoint.GameModel.freeBets.spinsPlayed > 0) {
                EntryPoint.GameModel.freeBetsStarted = false;
                popupData = {
                    title: {text: 'label_free_rounds_out_title'},
                    message: {
                        text: 'label_free_rounds_out_text',
                        params: [MoneyFormat.format(EntryPoint.GameModel.freeBets.win, false), MoneyFormat.gameCurrency]
                    },
                    confirmCallback: this.endFreeRounds,
                    confirmContext: this,
                    type: 'message'
                };
                messagesData = null;
            } else if (!EntryPoint.GameModel.freeBetsPaused && EntryPoint.GameModel.freeBets) {
                if (!EntryPoint.GameModel.freeBetsStarted) {
                    popupData = {
                        title: {text: 'label_free_rounds_award_title'},
                        message: {text: 'label_free_rounds_award_text', params: [EntryPoint.GameModel.freeBets.spins]},
                        confirmCallback: this.startFreeRounds,
                        confirmContext: this,
                        type: 'message'
                    };
                } else {
                    this.startFreeRounds();
                }
                messagesData = {
                    message: 'label_free_rounds_counter_title',
                    params: [EntryPoint.GameModel.freeBets.spins]
                };
            }

            if (popupData) {
                GlobalDispatcher.dispatch('popupContainer:showPopup', popupData);
                GlobalDispatcher.dispatch('topMessageContainer:setText', messagesData);
            }
        } else {
            if(EntryPoint.GameModel.isFreeSpins) {
                return;
            }

            if (EntryPoint.GameModel.freeBetsStarted) {
                ErrorsManager.getError({errorCode: 'connection'});
            }
            // if we end up here it means we did not have any stats.freespins
            // so make sure we stop any started freebets.
            this.endFreeRounds();
        }
    }

    endFreeRounds() {
        //update balance
        EntryPoint.GameModel.balance = EntryPoint.GameModel.balance;

        EntryPoint.GameModel.freeBetsStarted = false;
        EntryPoint.GameModel.freeBets = null;
    }

    onEndFreeSpinsOutState() {
        EntryPoint.GameModel.freeBetsPaused = false;

        EntryPoint.AutoPlaySettings.paused = false;
    }
}
